import { Reducer } from 'redux';
import { MrzDataState } from './types';
import { StudentActionTypes } from '../types';
import { countries } from 'data';

const reducer: Reducer<MrzDataState | null> = (state = null, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS: {
      const { mrzData } = action.payload.student;
      let nationality: string;
      if (mrzData && 'nationality' in mrzData) {
        const country = countries.find(country => country.alphaThree === mrzData.nationality);
        nationality = country ? country.nationality : undefined;
      }
      return {
        ...action.payload.student.mrzData,
        nationality,
      };
    }
    case StudentActionTypes.UPDATE_CONFLICT_SUCCESS:
    case StudentActionTypes.UPDATE_OFFER_EVIDENCE_SUCCESS: {
      if (action.payload.mrzData) {
        return {
          ...action.payload.mrzData,
        };
      }
      return state;
    }
    default:
      return state;
  }
};

export { reducer as MrzDataReducer };
